import { useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { enmStopFreeSaleStatus } from "../../models/enums/StopFreeSaleStatus";

export type StopFreeSaleReportStatusSelectProps = {
    onChange?: Function;
    defaultValue?: any;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    specificTypes?: enmStopFreeSaleStatus[];
}

export const StopFreeSaleReportStatusSelect = (props: StopFreeSaleReportStatusSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    let items: { name: string; id: number }[] = (props.specificTypes ? ObjectHelper.getEnumKeyValuesForSpecificTypes(enmStopFreeSaleStatus, props.specificTypes) : ObjectHelper.enumToObjectArray(enmStopFreeSaleStatus));

    return (
        <>
            <Select
                mode={props.mode}
                size="middle"
                defaultValue={props.mode == "multiple" ? props.defaultValue as number[] : props.defaultValue as number}
                value={props.mode == "multiple" ? props.value as number[] : props.value as number}
                onChange={(value: number | number[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.choose")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={items?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
}